import MuiListItemIcon from '@mui/material/ListItemIcon';
import { styled } from '@mui/material/styles';

var ListItemIcon = styled(MuiListItemIcon)(function (_a) {
    var theme = _a.theme, _b = _a.size, size = _b === void 0 ? 'medium' : _b;
    var _c = theme.componentsConfig, svgIcon = _c.svgIcon, listItemIcon = _c.listItemIcon;
    return {
        minWidth: svgIcon.size[size] + listItemIcon.spacing,
    };
});

export { ListItemIcon as default };
